<div style="background: white;
padding: 4rem;
border-radius: 10px">
    <img class="m-auto" src="../../../../assets/success.gif" alt="">
    <h2>Updated successfully!</h2>
    <button (click)="success()" type="button" class="w-full text-green-700 hover:text-white border border-green-700 hover:bg-green-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2 dark:border-green-500 dark:text-green-500 dark:hover:text-white dark:hover:bg-green-600 dark:focus:ring-green-800">OK</button>
</div>
